import React from 'react';

type CssValue = string | number | undefined;

interface AdyenStyleRule {
  selector: string;
  vars: Record<string, CssValue>;
}

// Converts a vars map to CSS custom property declarations, skipping undefined values.
// Numbers are converted to px (e.g. fontSize: 12 → font-size: 12px).
const toCssString = (vars: Record<string, CssValue>): string =>
  Object.entries(vars)
    .filter(([, value]) => value != null)
    .map(([prop, value]) => {
      const resolved = typeof value === 'number' ? `${value}px` : value;
      return `${prop}: ${resolved};`;
    })
    .join(' ');

// Builds a <style> tag from a list of selector + CSS variable overrides.
// Rules with no defined vars are omitted entirely.
export const buildAdyenStyles = (rules: AdyenStyleRule[]): React.ReactElement | null => {
  const css = rules
    .map(({ selector, vars }) => {
      const body = toCssString(vars);
      return body ? `${selector} { ${body} }` : null;
    })
    .filter(Boolean)
    .join('\n');

  return css ? <style>{css}</style> : null;
};
